import { CachesDirectoryPath, DocumentDirectoryPath } from "~/ui/fs"
// filesystem related api

// 手机缓存路径
export const CacheDir = CachesDirectoryPath

export const DocumentDir = DocumentDirectoryPath
